import { call } from '@advanza/api'
import { SystemLogRelation } from '@trustoo/types/entity/systemLog'
import { useAppDispatch, useAppSelector } from 'hooks/hooks'
import { useList } from 'hooks/listHooks'
import { schema } from 'normalizr'
import { useEffect } from 'react'

export interface SelectableLogType {
    value: string
    name: string
}

export const useLogsList = (isProLogs: boolean, filterId: string, defaultOptions: object = {}) => {
    const options = isProLogs
        ? {
              url: 'office/providers/get-logs-list',
              schema: [new schema.Entity('logs', {}, { idAttribute: 'log_id' })],
              reducerKey: 'logs',
          }
        : {
              url: 'office/services/get-system-logs-list',
              schema: [new schema.Entity('system_logs', {}, { idAttribute: 'system_log_id' })],
              reducerKey: 'system_logs',
          }
    return useList(filterId, options, defaultOptions)
}

export const useLogTypes = (
    isProLogs: boolean,
    {
        selectableLogTypes,
        relation,
    }: {
        selectableLogTypes?: SelectableLogType[]
        relation?: SystemLogRelation
    } = {},
) => {
    const dispatch = useAppDispatch()
    const proLogTypes: string[] | undefined = useAppSelector((state) => state.logs.logTypes)
    const systemLogTypes: Record<string, string[]> = useAppSelector(
        (state) => state.system_logs.log_types,
    )

    useEffect(() => {
        if (selectableLogTypes) {
            return
        }

        if (isProLogs && !proLogTypes) {
            call('office/providers/get-log-types').then(({ logTypes }) =>
                dispatch({ type: 'RECEIVE_LOG_TYPES', logTypes }),
            )
        } else if (!isProLogs && relation && !systemLogTypes[relation]) {
            call('office/services/get-system-logs-types/' + relation).then(({ types }) => {
                dispatch({ type: 'RECEIVE_SYSTEM_LOGS_TYPES', relation, types })
            })
        }
    }, [])

    return (isProLogs ? proLogTypes : relation && systemLogTypes[relation]) || []
}
